(function () {
  const contentLayoutB = document.querySelector(".main-content product-layout-b-content");
  const contentLayoutBFormButton = document.querySelector(".main-content product-layout-b-content [data-product-form]");
  const wrapperWrapper = document.querySelector(".product-page product-form");
  const wrapper = document.querySelector(".product-page [data-product-form]");
  const defaultSwitchFixed = () => {
    const offsetTop = $(wrapperWrapper).offset().top + 50;
    if (document.scrollingElement.scrollTop + window.innerHeight < offsetTop) {
      wrapper.classList.add("fixed");
      document.body.classList.add("is-product-bar--fixed");
    } else if (document.scrollingElement.scrollTop > offsetTop) {
      wrapper.classList.add("fixed");
      document.body.classList.add("is-product-bar--fixed");
    } else {
      document.body.classList.remove("is-product-bar--fixed");
      wrapper.classList.remove("fixed");
    }
  }
  const isInViewport = (element) => {
    if (!element) return false;
    const $el = $(element);
    const top = $el.offset().top;
    const bottom = top + $el.outerHeight();
    const scrollTop = document.scrollingElement.scrollTop;
    const viewportBottom = scrollTop + window.innerHeight;
    return top < viewportBottom && bottom > scrollTop;
  };
  const isAboveViewport = (element) => {
    if (!element) return false;
    const $el = $(element);
    return $el.offset().top + $el.outerHeight() < document.scrollingElement.scrollTop;
  };
  const layoutBSwitchFixed = () => {
    if (isAboveViewport(contentLayoutBFormButton) && !isInViewport(wrapperWrapper)) {
      wrapper.classList.add("fixed");
      document.body.classList.add("is-product-bar--fixed");
    } else {
      document.body.classList.remove("is-product-bar--fixed");
      wrapper.classList.remove("fixed");
    }
  }
  const switchFixed = () => {
    if (window.innerWidth < 768) {
      defaultSwitchFixed();
    } else {
      if (contentLayoutB) {
        layoutBSwitchFixed();
      } else {
        defaultSwitchFixed();
      }
    }
  }
  window.addEventListener("scroll", switchFixed);
  switchFixed();
})();

/* hide variant unavailable start */
const variantSelectsList = document.querySelectorAll('product-layout-b-content [data-product-block-variants], .product-single [data-product-block-variants]');
for (const variantSelects of variantSelectsList) {
  const variantFormSelectors = variantSelects.querySelector('.form__selectors');

  const pickerType = (variantSelects.querySelectorAll('fieldset').length > 0) ? 'radios' : 'selects';
  const fieldsets = (pickerType == 'radios') ? Array.from(variantFormSelectors.querySelectorAll('fieldset')) : Array.from(variantFormSelectors.querySelectorAll('.product-form__input--dropdown'));
  const productJson = JSON.parse(variantSelects.querySelector('[data-product-variants-json]').textContent);

  if (!variantFormSelectors || !productJson) {
    continue;
  }
  let selectedOptions = [];
  variantFormSelectors.addEventListener('change', rebuildOptions);
  rebuildOptions();
  function validCombo(inputValue, optionLevel) {
    for (let i = 0; i < productJson.length; i++) {
      if (optionLevel == 1) {
        if (productJson[i].option1 == selectedOptions[0] && productJson[i].option2 == inputValue) { return true; }
      } else {
        if (productJson[i].option1 == selectedOptions[0] && productJson[i].option2 == selectedOptions[1] && productJson[i].option3 == inputValue) { return true; }
      }
    }
  }

  function rebuildOptions() {
    selectedOptions = fieldsets.map((fieldset) => {
      return (pickerType == 'radios') ? Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value : Array.from(fieldset.querySelectorAll('select'), (select) => select.value);
    });
    for (let optionLevel = 1, n = fieldsets.length; optionLevel < n; optionLevel++) {
      const inputs = (pickerType == 'radios') ? fieldsets[optionLevel].querySelectorAll('input') : fieldsets[optionLevel].querySelectorAll('option');
      inputs.forEach(input => {
        input.disabled = (validCombo(input.value, optionLevel)) ? false : true;
        if (pickerType == 'radios') {
          const label = fieldsets[optionLevel].querySelector(`label[for="${input.id}"]`);
          const parentRadioSwatch = label.closest('radio-swatch');
          if (parentRadioSwatch) {
            parentRadioSwatch.style.display = (input.disabled) ? "none" : "";
          }
        } else {
          input.hidden = (validCombo(input.value, optionLevel)) ? false : true;
        }
      });
    }

    for (let optionLevel = 1, fieldsetsLength = fieldsets.length, change = false; optionLevel < fieldsetsLength && !change; optionLevel++) {
      if (pickerType == 'radios') {
        if (fieldsets[optionLevel].querySelector('input:checked').disabled === true) {
          const inputElement = fieldsets[optionLevel].querySelector('input:not(:disabled)');
          if (inputElement) {
            inputElement.checked = true;
            change = true;
            inputElement.dispatchEvent(new Event('change'));
          }
        }
      } else {
        if (fieldsets[optionLevel].querySelector('option:checked').disabled === true) {
          change = (fieldsets[optionLevel].querySelector('option:not(:disabled)').selected = "selected");

        }
      }

      if (change) variantFormSelectors.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}
/* hide variant unavailable end */